import { render, staticRenderFns } from "./WillSendConfirmationMessage.vue?vue&type=template&id=04180ca0&"
import script from "./WillSendConfirmationMessage.vue?vue&type=script&lang=js&"
export * from "./WillSendConfirmationMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports